// @flow
// eslint-env browser

export const dynamicId = (() => {
    const state = {};
    return (id: string) => {
        if (typeof state[id] !== 'number') {
            // WaPo's dynamic mapping starts from 2
            state[id] = 2;
            return id;
        }
        return [id, state[id]++].join('_');
    };
})();
